export var KEY = '---------';
export default function separatorItem() {
  return {
    name: KEY
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/contextMenu/predefinedItems/separator.js
// module id = /5z9
// module chunks = 0